// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");
console.log("Root container:", container);
if (!container) {
  throw new Error("No root element found. Ensure your public/index.html has a <div id='root'></div>.");
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
